import { render, staticRenderFns } from "./TempIndex.vue?vue&type=template&id=fc68db92&scoped=true&"
import script from "./TempIndex.vue?vue&type=script&lang=ts&"
export * from "./TempIndex.vue?vue&type=script&lang=ts&"
import style0 from "./TempIndex.vue?vue&type=style&index=0&id=fc68db92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc68db92",
  null
  
)

export default component.exports